import { gql } from '@apollo/client';
/**
 * @const PartnerStoreQuery
 * @since 1.0.0
 * Partner whose store is enabled under the slug, null otherwise.
 */
export const PartnerStoreQuery = gql `
  query PartnerStoreQuery($input: PartnerStoreInput!) {
    partnerStore(input: $input) {
      id
      name
      image {
        id
        url
        thumbnail
        thumbnailWidth
        display
        displayWidth
      }
    }
  }
`;
